import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import { HttpService, StatusService } from 'ui-components/common';
import { FavoriteViewForm } from './../com/ibm/tw/commons/mvc/favorite.viewform';
import { AxthenticationService } from './../services/axthentication.service';
import { ShareService } from './../services/share.service';
import { TxnService } from './../services/txn.service';

/**
 * 	Ccmhmtodo Service
 *
 * @author Benny
 * @version 1.0, 2017/09/11
 * @see
 * @since
 */
@Injectable({
    providedIn: 'root'
})
export class PageCodeService extends TxnService {

    constructor(
        protected http: HttpService,
        protected shareService: ShareService,
        protected router: Router,
        protected axthenticationService: AxthenticationService,
        protected statusService: StatusService
    ) {
        super(http, shareService, router, axthenticationService, statusService);
        // console.log('PageCodeService Init');
    }

    /**
     * 新增到我的最愛
     */
    updateFavoriteTask(favoriteViewForm: FavoriteViewForm): Observable<FavoriteViewForm> {
        if (!this.axthenticationService.isLoggedIn) {
            return;
        }
        let response: Observable<FavoriteViewForm> = this.axthenticationService.doPostToBackEnd<FavoriteViewForm>(
            favoriteViewForm,
            favoriteViewForm,
            '/ccmpsmyfahome/addFavoriteTask'); //  '/pagecode/cps/ccmpsmyfa/ccmpsmyfahome/addFavoriteTask'
        return response;
    }

    /**
     * 更新我的最愛清單
     */
    updateFavoriteTaskList(favoriteViewForm: FavoriteViewForm): Observable<FavoriteViewForm> {
        if (!this.axthenticationService.isLoggedIn) {
            return;
        }
        let response: Observable<FavoriteViewForm> = this.axthenticationService.doPostToBackEnd<FavoriteViewForm>(
            favoriteViewForm,
            favoriteViewForm,
            '/ccmpsmyfahome/updateFavoriteTaskList'); //  '/pagecode/cps/ccmpsmyfa/ccmpsmyfahome/updateFavoriteTaskList'
        return response;
    }
}
